import PptxGenJS from 'pptxgenjs';
import { toBulletRuns } from '../helpers';
import {
    addConfidentialDisclaimer,
    addProjectBadge,
    addBulletsSection,
    addSlideTitle,
    regularSlideGradient
} from '../template-parts';
import { PPTImageManager } from '../helpers/image-manager';

interface ConnectionInfraData {
    projectTitle?: string;
    logoBlack?: any;
    project: any
}

const Y_TITLE = 1.71;
const Y_BODY = 2.04;
const H_BODY = 3;

export function connectionInfraSlide(pptx: PptxGenJS, data: ConnectionInfraData, imageManager: PPTImageManager) {

    const slide = pptx.addSlide();
    const logoBlack = imageManager.get('logo-black');
    const icon = imageManager.get('cable');
    const { connectionInfra } = data.project;

    // === 1) Background gradient ===
    regularSlideGradient(slide);

    // === 2) Logo black ===
    if (logoBlack) {
        slide.addImage({
            data: logoBlack,
            x: 5.26,
            y: 0.24,
            w: 1.92,
            h: 0.58,
        });
    }

    // === 3) Badge PROJECT XXX
    const badgeText = (data.projectTitle ?? 'PROJECT XXX').toUpperCase();
    addProjectBadge(slide, badgeText);

    // === 4) Title slide ===
    addSlideTitle(slide, 'Project XXX');

    // === 5) Content ===
    const connectionInfraBullets = toBulletRuns(connectionInfra);
    addBulletsSection(slide, 'Connection Infrastructure', connectionInfraBullets, Y_TITLE, Y_BODY, H_BODY, icon);

    // Confidential disclaimer
    addConfidentialDisclaimer(slide);
}
